import ReactDOM from "react-dom/client";
import { Routes, Route, BrowserRouter, Outlet } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";

import "./index.scss";

import { UserProvider } from "./components/user-provider";
import { ShowByUserType } from "./components/show-by-user-type/show-by-user-type";
import { WeekSchedulePage } from "./pages/WeekSchedulePage";
import { WorkingTimePage } from "./pages/WorkingTimePage";
import { EmployeesPage } from "./pages/EmployeesPage";
import { ServicesPage } from "./pages/ServicesPage";
import { MyProfilePage } from "./pages/MyProfilePage";
import { ServiceCategoriesPage } from "./pages/ServiceCategoriesPage";
import { LogoutPage } from "./pages/LogoutPage";
import { HomePage } from "./pages/HomePage";
import { MSAL_INSTANCE } from "./api/api-config";
import { AuthProvider } from "./components/auth-provider";
import { CallbackPage } from "./pages/CallbackPage";
import { AuthElement } from "./components/auth-element/auth-element";
import { OrganizationDetailsContextHandler } from "./components/organization-details-context";
import { BetterNavigate } from "./components/better-navigate";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const OrganizationRoot = () => {
  return (
    <OrganizationDetailsContextHandler>
      <AuthElement>
        <UserProvider>
          <Outlet />
        </UserProvider>
      </AuthElement>
    </OrganizationDetailsContextHandler>
  );
};

root.render(
  <BrowserRouter>
    <MsalProvider instance={MSAL_INSTANCE}>
      <AuthProvider>
        <Routes>
          <Route
            path="/logout"
            element={
              <AuthElement>
                <LogoutPage />
              </AuthElement>
            }
          />
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/:organizationAlias" element={<OrganizationRoot />}>
            <Route
              index
              element={<BetterNavigate to="schedule-week" replace />}
            />
            <Route path="schedule-week" element={<WeekSchedulePage />} />
            <Route path="working-time" element={<WorkingTimePage />} />
            <Route
              path="workers"
              element={
                <ShowByUserType>
                  <EmployeesPage />
                </ShowByUserType>
              }
            />
            <Route
              path="services"
              element={
                <ShowByUserType>
                  <ServicesPage />
                </ShowByUserType>
              }
            />
            {/* <Route
                    path="settings"
                    element={
                      <ShowByUserType>
                          <SettingsPage />
                      </ShowByUserType>
                    }
                /> */}
            <Route path="profile" element={<MyProfilePage />} />
            <Route
              path="service-categories"
              element={
                <ShowByUserType>
                  <ServiceCategoriesPage />
                </ShowByUserType>
              }
            />
          </Route>
          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<BetterNavigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </MsalProvider>
  </BrowserRouter>,
);
